import { NavLink } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { LayoutDashboard, Layers, Lock, CalendarClock, BrainCircuit, Eye, Landmark, FileText, Upload, DatabaseZap, Settings, Users } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_vault-truth/artifacts/s3q6fukn_image.png";

const navItems = [
  { to: "/dashboard", icon: LayoutDashboard, key: "sidebar.dashboard", end: true },
  { to: "/dashboard/bank", icon: Landmark, key: "sidebar.bank" },
  { to: "/dashboard/data-pool", icon: DatabaseZap, key: "sidebar.dataPool" },
  { to: "/dashboard/bubbles", icon: Layers, key: "sidebar.bubbles" },
  { to: "/dashboard/vaults", icon: Lock, key: "sidebar.vaults" },
  { to: "/dashboard/obligations", icon: CalendarClock, key: "sidebar.obligations" },
  { to: "/dashboard/counterparties", icon: Users, key: "sidebar.counterparties" },
  { to: "/dashboard/report", icon: FileText, key: "sidebar.report" },
  { to: "/dashboard/insights", icon: BrainCircuit, key: "sidebar.insights" },
  { to: "/dashboard/sentinel", icon: Eye, key: "sidebar.sentinel" },
  { to: "/dashboard/settings", icon: Settings, key: "sidebar.settings" },
];

export default function Sidebar() {
  const { i18n } = useAuth();

  return (
    <aside className="w-[220px] hidden lg:flex flex-col bg-[#0B1120] border-r border-slate-800/50 shrink-0" data-testid="sidebar">
      <a
        href="/"
        className="p-4 flex items-center gap-3 border-b border-slate-800/50 cursor-pointer hover:bg-slate-800/30 transition-colors"
        data-testid="sidebar-logo-link"
        title="Back to homepage"
      >
        <img src={LOGO_URL} alt="Sentient Vault" className="w-10 h-10 object-contain" />
        <div>
          <h1 className="font-barlow font-bold text-lg text-slate-50 tracking-tight leading-none">SENTIENT VAULT</h1>
          <span className="text-[8px] text-amber-400/70 font-manrope tracking-[0.25em] uppercase">Obligation-Enforced</span>
        </div>
      </a>

      <nav className="flex-1 p-3 space-y-1">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            data-testid={`nav-${item.key.replace('sidebar.', '')}`}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 group ${
                isActive
                  ? "bg-slate-800/80 text-amber-400 shadow-[0_0_12px_rgba(245,158,11,0.08)]"
                  : "text-slate-400 hover:text-slate-200 hover:bg-slate-800/40"
              }`
            }
          >
            <item.icon className="w-[18px] h-[18px] shrink-0" />
            <span className="font-manrope">{i18n(item.key)}</span>
          </NavLink>
        ))}
      </nav>

      <div className="p-4 border-t border-slate-800/50">
        <div className="text-[10px] text-slate-600 font-mono tracking-wide">
          v0.1.0 MVP &middot; {i18n("sidebar.version")}
        </div>
      </div>
    </aside>
  );
}
